import { useState } from 'react';
import { Button } from '@artosera/ui';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import {
  useHistoriqueLocations,
  useLocations,
  type ContratLocationPresente,
} from '../../api/locations.js';
import styles from './Locations.module.css';

function Liste({
  galerieSlug,
  contrats,
  erreur,
  attente,
}: {
  galerieSlug: string;
  contrats: ContratLocationPresente[] | undefined;
  erreur: boolean;
  attente: boolean;
}) {
  const { t } = useTranslation(['regie', 'commun']);
  return (
    <div className={styles.liste}>
      {attente && <p role="status">{t('commun:chargement')}</p>}
      {erreur && <p role="alert">{t('commun:erreurReseau')}</p>}
      {contrats?.length === 0 && <p>{t('locations.aucun')}</p>}
      {contrats?.map((c) => (
        <Link className={styles.ligne} key={c.id} to={`/${galerieSlug}/locations/${c.id}`}>
          <strong>{c.numero}</strong>
          <span>
            {c.debutLe} — {c.finLe ?? '…'}
          </span>
          <span>{t(`locations.etats.${c.etatEffectif}`)}</span>
        </Link>
      ))}
    </div>
  );
}
export function LocationsOeuvre({
  galerieSlug,
  oeuvreId,
}: {
  galerieSlug: string;
  oeuvreId: string;
}) {
  const liste = useHistoriqueLocations(galerieSlug, oeuvreId);
  return (
    <Liste
      galerieSlug={galerieSlug}
      contrats={liste.data?.contrats}
      erreur={liste.isError}
      attente={liste.isPending}
    />
  );
}
export function LocationsContact({
  galerieSlug,
  contactId,
}: {
  galerieSlug: string;
  contactId: string;
}) {
  const { t } = useTranslation('regie');
  const [page, setPage] = useState(1);
  const liste = useLocations(galerieSlug, { locataireId: contactId, page });
  return (
    <section>
      <h2>{t('locations.contratsContact')}</h2>
      <Liste
        galerieSlug={galerieSlug}
        contrats={liste.data?.contrats}
        erreur={liste.isError}
        attente={liste.isPending}
      />
      {liste.data && liste.data.pagination.pages > 1 && (
        <div>
          <Button disabled={page === 1} onClick={() => setPage(page - 1)}>
            {t('locations.precedent')}
          </Button>
          <Button disabled={page >= liste.data.pagination.pages} onClick={() => setPage(page + 1)}>
            {t('locations.suivant')}
          </Button>
        </div>
      )}
    </section>
  );
}
